import React, { useRef, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { LangButton } from "../../../language/lang-button";
import { NotificationButton } from "../../components/notification-button";
import { useAccessibility } from "../../../../hooks/useAccessibility";
import { store } from "../../../Store";

/**
 * Componente que renderiza los botones Ingresar, accesibilidad, notificaciones e idioma
 * @param {*} textosInterfaz - objeto con los textos de interfaz 
 * @returns {JSX.Element} Tools
 */
export const Tools = ({ textosInterfaz }) => {
    const location = useLocation();

    const globalState = useContext(store);
    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);

    return (
        <ul className="option-nav d-flex justify-content-end aling-items-center">
                    <li className="mr-2">
                        <Link
                            to="/login"
                            className={`focusable-red buttonv2 button-black py-2 px-3 btn-secondary-nav`}
                        >
                            <Icon icon="wordpress:login" className="surface--color" width={30} />
                            {textosInterfaz?.ingresar || 'Ingresar'}
                        </Link>
                    </li>
                    <li className="mr-3">
                        <Link
                            to={'/contacto'}
                            className={`focusable-red ml-1 buttonv2 button-primary-var2 p-3 btn-secondary-nav`}
                        >
                            {textosInterfaz?.pedir_demo || 'Pide un demo'}

                        </Link>
                    </li>
        </ul>
    )
}